import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Navbar, Nav ,NavDropdown, MenuItem } from 'react-bootstrap'
import T from 'common/Text'
import './style.css';
import { LANG_CODE, LANG_TEXT } from 'constants/language-code'
import { withRouter } from "react-router-dom";
import { fetchLanguage } from 'redux/actions/app'
import Logo from 'media/img/logo.gif'
import { Link } from "react-router-dom";

class NavBar extends Component {
    constructor(props){
        super(props);
        this.state = {
            expanded : false,
        }
        this.toggleNavExpand = this.toggleNavExpand.bind(this);
        this.routeTo = this.routeTo.bind(this);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.props !== nextProps || this.state !== nextState;
    }

    scrollTop(){
        window.scrollTo(0,0);
    }

    toggleNavExpand(){
        var windowWidth = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;
        if(windowWidth<768){
            this.setState((state)=>({
                expanded:!state.expanded
            }))
        }
        
    }
    routeTo(link){
        this.toggleNavExpand(); 
        this.scrollTop();
        this.props.history.push(link);
    }
    
    render() {
        const currentPage = this.props.location.pathname;
        const { lang } = this.props.app;

        return (
            <Navbar onToggle={this.toggleNavExpand} expanded={this.state.expanded} inverse fixedTop>
                <Navbar.Header>
                    <a href="/"><img className="logo" src={Logo} alt=""/></a>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>

                    <Nav pullRight>
                        <li className={currentPage === '/about-us' ? 'active' : ''}>
                            <Link to='/about-us' onClick={()=>{this.toggleNavExpand(); this.scrollTop()}}><T id='ABOUT_US' /></Link>
                        </li>
                        {/* <li className={currentPage === '/fall-winter-jp-2024' ? 'active' : ''}>
                            <Link to='/fall-winter-jp-2024' onClick={()=>{this.toggleNavExpand(); this.scrollTop()}}><T id='FALL_WINTER_JP_2024' /></Link>
                        </li> */}
                        <NavDropdown title={<T id='EVENT' />} id="event-menu">
                           
                            <NavDropdown title={<T id='INT' />} id="int-submenu">
                                
                                <MenuItem onSelect={()=>{this.routeTo("/int1");}}>
                                    <T id='INT1' />
                                </MenuItem>
                                <MenuItem onSelect={()=>{this.routeTo("/int2");}}>
                                    <T id='INT2' />
                                </MenuItem>
                                <MenuItem onSelect={()=>{this.routeTo("/int3");}}>
                                    <T id='INT3' />
                                </MenuItem>
                            </NavDropdown>

                            <NavDropdown title={<T id='I_LOVE_DAD' />} id="love-data-submenu">
                                <MenuItem onSelect={()=>{this.routeTo("/i-love-dad-2023");}}>
                                    <T id='I_LOVE_DAD_2023' />
                                </MenuItem>
                                <MenuItem onSelect={()=>{this.routeTo("/i-love-dad");}}>
                                    <T id='I_LOVE_DAD_2022' />
                                </MenuItem>
                            </NavDropdown>
                 

                            
                            
                        </NavDropdown>
                        <NavDropdown title={<T id='PASTCOMP' />} id="year-2021-dropdown">    
                            <MenuItem onSelect={()=>{this.routeTo("/spring-summer-jp-2026");}}>
                                <T id='SPRING_SUMMER_JP_2026' />
                            </MenuItem>                        
                            <MenuItem onSelect={()=>{this.routeTo("/fall-winter-jp-2025");}}>
                                <T id='FALL_WINTER_JP_2025' />
                            </MenuItem>                        
                            <MenuItem onSelect={()=>{this.routeTo("/spring-summer-jp-2025");}}>
                                <T id='SPRING_SUMMER_JP_2025' />
                            </MenuItem>                        
                            <MenuItem onSelect={()=>{this.routeTo("/fall-winter-jp-2024");}}>
                                <T id='FALL_WINTER_JP_2024' />
                            </MenuItem>
                            <MenuItem onSelect={()=>{this.routeTo("/spring-summer-jp-2024");}}>
                                <T id='SPRING_SUMMER_JP_2024' />
                            </MenuItem>
                            <MenuItem onSelect={()=>{this.routeTo("/fall-winter-jp-2023");}}>
                                <T id='FALL_WINTER_JP_2023' />
                            </MenuItem>
                            <MenuItem onSelect={()=>{this.routeTo("/spring-summer-jp-2023");}}>
                                <T id='SPRING_SUMMER_JP_2023' />
                            </MenuItem>
                            <MenuItem onSelect={()=>{this.routeTo("/fall-winter-jp-2022");}}>
                                <T id='FALL_WINTER_JP_2022' />
                            </MenuItem>
                            <MenuItem onSelect={()=>{this.routeTo("/spring-summer-jp-2022");}}>
                                <T id='SPRING_SUMMER_JP_2022' />
                            </MenuItem>
                            <MenuItem onSelect={()=>{this.routeTo("/fall-winter-jp-2021");}}>
                                <T id='FALL_WINTER_JP_2021' />
                            </MenuItem>
                            <MenuItem onSelect={()=>{this.routeTo("/asia-jp-award");}}>
                                <T id='ASIA_JP_AWARD' />
                            </MenuItem>
                            <MenuItem onSelect={()=>{this.routeTo("/hk-jp-award");}}>
                                <T id='HJ_AWARD' />
                            </MenuItem>
                            <MenuItem onSelect={()=>{this.routeTo("/fall-winter-gallery")}}>
                                <T id='AUTUMN_WINTER_AWARD' />
                            </MenuItem>
                            <MenuItem onSelect={()=>{this.routeTo("/spring-summer-winner")}}>
                                <T id='SPRING_SUMMER_AWARD' />
                            </MenuItem>
                            <MenuItem onSelect={()=>{this.routeTo("/annual-winner")}}>
                                <T id='ANNUAL_AWARD' />
                            </MenuItem>
                            
                            
                        </NavDropdown>
                        {/* <li className={currentPage === '/fall-winter-jp-2021' ? 'active' : ''}>
                            <Link to='/fall-winter-jp-2021' onClick={()=>{this.toggleNavExpand(); this.scrollTop()}}><T id='FALL_WINTER_JP_2021' /></Link>
                        </li> */}
                        {/* <li className={currentPage === '/asia-jp-award' ? 'active' : ''}>
                            <Link to='/asia-jp-award' onClick={()=>{this.toggleNavExpand(); this.scrollTop()}}><T id='ASIA_JP_AWARD' /></Link>
                        </li> */}
                        {/* <li className={currentPage === '/hk-jp-award' ? 'active' : ''}>
                            <Link to='/hk-jp-award' onClick={()=>{this.toggleNavExpand(); this.scrollTop()}}><T id='HJ_AWARD' /></Link>
                        </li> */}
                        {/* <li className={currentPage === '/fall-winter-gallery' ? 'active' : ''}>
                            <Link to='/fall-winter-winner' onClick={()=>{this.toggleNavExpand(); this.scrollTop()}}><T id='AUTUMN_WINTER_AWARD' /></Link>
                        </li> */}
                        {/* <li className={currentPage === '/spring-summer-winner' ? 'active' : ''}>
                            <Link to='/spring-summer-winner' onClick={()=>{this.toggleNavExpand(); this.scrollTop()}}><T id='SPRING_SUMMER_AWARD' /></Link>
                        </li> */}
                        {/* <li className={currentPage === '/annual-winner' ? 'active' : ''}>
                            <Link to='/annual-winner'><T id='ANNUAL_AWARD' /></Link>
                        </li> */}
                        <li className={currentPage === '/contact-us' ? 'active' : ''}>
                            <Link to='/contact-us' onClick={()=>{this.toggleNavExpand(); this.scrollTop()}}><T id='CONTACT_US' /></Link>
                        </li>
                        
                        <NavDropdown title={LANG_TEXT[lang]} id="lang-dropdown">
                            <MenuItem className="Testt" onSelect={()=>{this.toggleNavExpand();this.props.fetchLanguage(LANG_CODE["JP"])}}>{LANG_TEXT[LANG_CODE["JP"]]}</MenuItem>
                            <MenuItem onSelect={()=>{this.toggleNavExpand();this.props.fetchLanguage(LANG_CODE["ZH"])}}>{LANG_TEXT[LANG_CODE["ZH"]]}</MenuItem>
                            <MenuItem onSelect={()=>{this.toggleNavExpand();this.props.fetchLanguage(LANG_CODE["EN"])}}>{LANG_TEXT[LANG_CODE["EN"]]}</MenuItem>
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        )

    }
}

const mapStateToProps = state => ({
    app: state.app
})

const mapDispatchToProps = {
    fetchLanguage
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavBar));



// WEBPACK FOOTER //
// ./src/common/nav-bar/index.js